import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { MenusDataService, MenusColumnsService } from '../../../services';
import { Menu, MenusResult } from '../../../interfaces';
import { Editor } from 'primeng/editor';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { EditorService } from '../../../../services/editor/editor.service';
import { DialogFilerComponent } from '../../filer/filer.component';

@Component({
  selector: 'app-menu-form',
  templateUrl: './menu-form.component.html',
  styleUrls: ['./menu-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class MenuFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public menu: Menu = {};
  public menuForm: FormGroup = new FormGroup({});
  public menus: Menu[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  public Editor = ClassicEditor;
  private filerDialog: DynamicDialogRef = new DynamicDialogRef();

  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private menusDataService: MenusDataService,
    public menusColumnsService: MenusColumnsService,
    public editorService: EditorService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'MenuFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('menu - Edit');
        this.getMenu(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.menu !== 'undefined') {
      this.menu = this.dynamicDialogConfig.data.menu;
    }
    if (typeof this.menu.id === 'undefined' || this.menu.id === null) {
      this.menu.id = null;
      this.menu.startPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.menu.endPublishing = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
      this.menu.publishDate = moment().set({minute: 0, second: 0, millisecond: 0}).format('YYYY-MM-DD\THH:mm:ssZ');
    }
    this.getMenus();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'MenuFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'MenuFormComponent');
  }

  getMenu(id: number): void {
    this.isLoading = true;
    this.menusDataService.getMenu(id).subscribe((response: Menu|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.menu = response;
        this.prepareFrom();
      }
    });
  }

  getMenus(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.menus !== 'undefined' && this.dynamicDialogConfig.data.menus.length > 0) {
      this.menus = this.dynamicDialogConfig.data.menus;
      return;
    }
    this.menusDataService.getMenus(this.parameters).subscribe((response: MenusResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.menus = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.menu.startPublishing = moment(this.menu.startPublishing).toDate();
    this.menu.endPublishing = moment(this.menu.endPublishing).toDate();
    this.menu.publishDate = moment(this.menu.publishDate).toDate();
    this.menuForm = new FormGroup({
      id: new FormControl(this.menu.id, []),
      title: new FormControl(this.menu.title, []),
      titleAr: new FormControl(this.menu.titleAr, []),
      titleFr: new FormControl(this.menu.titleFr, []),
      slug: new FormControl(this.menu.slug, []),
      slugAr: new FormControl(this.menu.slugAr, []),
      slugFr: new FormControl(this.menu.slugFr, []),
      picture: new FormControl(this.menu.picture, []),
      content: new FormControl(this.menu.content, []),
      contentAr: new FormControl(this.menu.contentAr, []),
      contentFr: new FormControl(this.menu.contentFr, []),
      startPublishing: new FormControl(this.menu.startPublishing, []),
      endPublishing: new FormControl(this.menu.endPublishing, []),
      publishDate: new FormControl(this.menu.publishDate, [Validators.required, ]),
      status: new FormControl(this.menu.status, [Validators.required, ]),
      totalPrints: new FormControl(this.menu.totalPrints, []),
      totalHits: new FormControl(this.menu.totalHits, []),
      totalComments: new FormControl(this.menu.totalComments, []),
      totalRatings: new FormControl(this.menu.totalRatings, []),
      averageRatings: new FormControl(this.menu.averageRatings, []),
      totalLikes: new FormControl(this.menu.totalLikes, []),
      totalDislikes: new FormControl(this.menu.totalDislikes, []),
      totalBookmarks: new FormControl(this.menu.totalBookmarks, []),
    });
  }

  list() {
    this.router.navigate(['/menus']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.menuForm.controls).forEach((field: any) => {
        const control = this.menuForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.menuForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.menu = this.menuForm.value;
    this.disableSubmit = true;
    console.log('menu', this.menu);
    if (typeof this.menu.id !== 'undefined' && this.menu.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.menusDataService.updateMenu(this.menu).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('menuUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('menuNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.menusDataService.addMenu(this.menu).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('menuCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('menuNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

  openFilerDialog(field: string): void {
    let url = '';
    const control = this.menuForm.get(field);
    if (control !== null) {
      url = control.value;
    }
    this.filerDialog = this.dialogService.open(DialogFilerComponent, {
      header: '', // this.translate.instant('FILEMANAGER'),
      width: '90%',
      contentStyle: { 'height': '800px', overflow: 'auto' },
      baseZIndex: 1500,
      data: {
        path: 'menus',
        field: field,
        url: url,
      },
    });
    this.filerDialog.onClose.subscribe((response: any) => {
      if (response && response.selected) {
        const control = this.menuForm.get(field);
        if (control !== null) {
          control.setValue(response.selected.webPath);
        }
      }
    });
  }

}

@Component({
  selector: 'app-menu-form',
  templateUrl: './menu-form.component.html',
  styleUrls: ['./menu-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogMenuFormComponent extends MenuFormComponent {
}

